import * as React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import ArticleCard from "./Article";

import { useAppSelector } from "store/hooks";

import { styles } from "./styles";

const BlogArticles: React.FC = () => {
  const latestArticles = useAppSelector(
    (state) => state.home.latestBlogArticles,
  );

  if (!latestArticles.length) {
    return null;
  }

  return (
    <Box sx={styles.sectionBackground}>
      <Container>
        <Typography variant="subtitle1" color="error.dark">
          Все про перекази за реквізитами, безпеку та тренди фінтеху
        </Typography>
        <Typography variant="h2" color="primary" sx={{ mt: 2.5, mb: 7.5 }}>
          Новини та статті
        </Typography>

        <Stack sx={styles.articlesRow}>
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

export default BlogArticles;
